import builder from '../builder';
import RatingStar from '../../streamline-icons/light/rating-star.svg';

export default builder('IconRatingStarLight', RatingStar);
